// TYPES
import type { FailedResponse, SuccessResponse } from '..'

// UTILITIES
import { generateHeaders, createResponseObj } from '..'
import { vcBaseUrl } from '.'


type CreateGroupResponse = (SuccessResponse & {
    groupId: string
    message: string
}) | FailedResponse

export class CreateGroupRequest extends Request {
    private constructor(init?: RequestInit) { super(`${vcBaseUrl}/group`, init) }
    static async init(body: CreateGroupRequestBody, init?: RequestInit) {
        return new CreateGroupRequest({
            ...init,
            method: 'POST',
            headers: await generateHeaders("Clerk-Token", init?.headers),
            body: JSON.stringify(body),
        })
    }

    static async fetch(...args: Parameters<typeof this.init>) {
        const request = await this.init(...args)
        return await request.fetch()
    }

    public async fetch(): Promise<string> {
        const response = await fetch(this)
        const data = createResponseObj<CreateGroupResponse>(await response.json())
        console.info("Create Group Results:", data)
    
        switch (data.status) {
            case 'successful': return data.groupId
            case 'failed': throw data
            default: throw new Error(`Unsupported Status: ${data}`)
        }
    }
}